/* eslint-disable no-nested-ternary */
/* eslint-disable no-use-before-define */
import { useDispatch, useSelector } from 'react-redux';

import { getObjectMovements } from '@helpers';
import { fetchMovements } from '@store/transactions/actions';
import moment from 'moment';
import { getEnv } from '@config';

const useMovements = () => {
  const { merchant } = useSelector((state) => state.login);
  const {
    movements: { items },
    errorLastMovements,
  } = useSelector((state) => state.transactions);

  const dispatch = useDispatch();

  const getMovements = ({ text, endDate, startDate }) => {
    const { daysMovementsMax } = getEnv();
    const perPage = 1000;
    const endDateFilter = endDate ?? moment().format();
    const startDateFromFilter = startDate ?? moment(endDateFilter).subtract(daysMovementsMax, 'days').format();

    const isStartAfterEnd = moment(startDateFromFilter).isAfter(endDateFilter);
    const exceedsMaxDaysRange = moment(endDateFilter).diff(moment(startDateFromFilter), 'days') > daysMovementsMax;
    const startDateRange = isStartAfterEnd || exceedsMaxDaysRange
      ? moment(endDateFilter).subtract(daysMovementsMax, 'days').format()
      : startDateFromFilter;

    const requestBody = getObjectMovements(
      merchant.wallet_info?.merchant_id,
      startDateRange,
      endDateFilter,
      text,
      perPage
    );
    dispatch(fetchMovements(requestBody));
  };

  return {
    items,
    getMovements,
    errorLastMovements,
  };
};

export default useMovements;
